<template>
    <div style="background-color: #1f2d3d" :style="{ height: this.screenHeight + 'px' }" @dblclick="savedragBoardSetup()">
        <CKBoard ref="board" v-if="!video.boardListHide" :topRows="topRows" :downRows="downRows" :span="3" v-cloak @init="loadConfig" @loadTopList="loadTopList" @loadDownList="loadDownList" :BoardType="board_type" :BoardNo="board_no"></CKBoard>
        <div
            class="message"
            :class="{ active: isHide }"
            :style="{
                width: messageWidth + 'px',
                left: messageleft + 'px',
                'font-size': boardMessagefontsize + 'px'
            }"
        >
            <div class="patient_name">{{ message[0] }}</div>
            <div class="note">{{ message[1] }}</div>
        </div>
        <div
            v-if="videoSource && videoSource.length > 0"
            v-drag="video"
            draggable="false"
            class="video"
            :class="{ active: video.isHide }"
            :style="{
                top: video.top + 'px',
                left: video.left + 'px',
                width: video.width + 'px',
                height: video.height + 'px'
            }"
            @click="showBorder = true"
        >
            <!--        左右-->
            <div @mousedown="handleResize($event, 'left')" :class="showBorder ? `bordercircle circle circle-left ew-resize` : `circle circle-left ew-resize`"></div>
            <div @mousedown="handleResize($event, 'right')" :class="showBorder ? `bordercircle circle circle-right ew-resize` : `circle circle-right ew-resize`"></div>
            <!--        上下-->
            <div @mousedown="handleResize($event, 'top')" :class="showBorder ? `bordercircle circle circle-top ns-resize` : `circle circle-top ns-resize`"></div>
            <div @mousedown="handleResize($event, 'bottom')" :class="showBorder ? `bordercircle circle circle-bottom ns-resize` : `circle circle-bottom ns-resize`"></div>
            <!--        左上右下-->
            <div @mousedown="handleResize($event, 'leftTop')" :class="showBorder ? `bordercircle circle nwse-resize` : `circle nwse-resize`" style="top: -10px; left: -10px"></div>
            <div @mousedown="handleResize($event, 'rightBottom')" :class="showBorder ? `bordercircle circle nwse-resize` : `circle nwse-resize`" style="bottom: -10px; right: -10px"></div>
            <!--        左下右上-->
            <div @mousedown="handleResize($event, 'leftBottom')" :class="showBorder ? `bordercircle circle nesw-resize` : `circle nesw-resize`" style="bottom: -10px; left: -10px"></div>
            <div @mousedown="handleResize($event, 'rightTop')" :class="showBorder ? `bordercircle circle nesw-resize` : `circle nesw-resize`" style="top: -10px; right: -10px"></div>
            <video style="width: 100%; height: 100%; object-fit: fill" controls="" id="video1" autoplay="">
                <source v-for="item in videoSource" :key="item.id" :src="item.src" type="video/mp4" />
            </video>
        </div>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import axios from 'axios'
import CKBoard from './CKBoard'
import ElementUI from 'element-ui'
import { mapGetters } from 'vuex'
export default {
    name: `UnloginObstetricsBoardFamily`,
    components: { CKBoard },
    props: {},
    data() {
        return {
            page: 1,
            load_message: {},
            all_page: 1,
            message: [],
            noticeDatas: [],
            items1: [],
            items2: [],
            config: {},
            msg: ``,
            boardConfigPageInterval: 10,
            boardConfigAudio: 1,
            boardConfigFamilyPrivate: true,
            boardConfigRemainBuffer: 0.5,
            isHide: true,
            isHideOpenDiv: false,
            token: sessionStorage.getItem(`token`),
            dic_operating_room: undefined,
            role_ids: [],
            username: ``,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            speaking: null,
            board_type: 2,
            board_no: this.$route.query.board_no || `0`,
            messageWidth: 800,
            messageleft: ``,
            showBorder: false,
            boardMessagefontsize: this.$root.BoardMessagefontsize,
            video: {
                id: 0,
                top: 0,
                left: 0,
                width: `50%`,
                height: `450px`,
                isHide: true, // 视频默认隐藏
                boardListHide: false // 列表隐藏
            },
            videoData: {},
            videoList: [],
            scaleVal: 1,
            clientX: 0, // 当前事件触发时屏幕X轴位置
            clientY: 0, // 当前事件触发时屏幕Y轴位置
            w: 0,
            h: 0,
            x: 0,
            y: 0,
            isCircleMove: false,
            dic_operating_ward: this.$route.query.dic_operating_ward,
            Voices: [],
            boardNum: this.$route.query.boardNum,
            queryroomIds: this.$route.query.roomIds,
            querybedIds: this.$route.query.bedIds,
            boardFamilyConfig: this.$root.BoardFamilyConfig,
            roomIds: [],
            bedIds: [],
            boardConfigs: [],
            topRows: [],
            downRows: []
        }
    },
    created() {
        // let that = this
        this.showBorder = false
        this.getVoices()
        this.loadToken().then(() => {
            this.getBoardConfig().then(() => {
                console.log(`roomIds`, this.roomIds, this.bedIds)
                this.init().then(() => {
                    this.loadConfigs().then(() => {
                        this.loadFamilyList().then(() => {
                            this.setRowStyle(`top`)
                            this.setRowStyle(`down`)
                        })
                    })
                    this.reseveMessage()
                    let screenWidthme = document.documentElement.clientWidth
                    let screenHeightme = document.documentElement.clientHeight
                    this.messageWidth = screenWidthme * 0.5
                    this.messageleft = (screenWidthme * 0.5) - (this.messageWidth / 2)
                    this.messageHeight = screenHeightme * 0.5
                    this.messageTop = (screenHeightme * 0.5) - (this.messageHeight / 2)
                    this.timer()
                    // 获取本地IP地址
                    this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
                        this.loadBoardVideoSetup()
                    })
                })
            })
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`, `ward_auth`, `localip/ipAddress`]),
        // 计算属性的 getter
        videoSource: function() {
            return this.videoList
        }
    },
    mounted() {
        if (this.loadTime_timer) {
            clearInterval(this.loadTime_timer)
        }
    },
    methods: {
        getBoardConfig() {
            return new Promise(resolve => {
                let that = this
                let config = that.boardFamilyConfig && that.boardFamilyConfig.split(`|`) || [`0`]
                if (that.boardNum && config[0] != `0` && config[1]) {
                    let boardFamilyConfigobj = eval(
                        `(` + config[1] + `)`
                    )
                    var info = _.find(boardFamilyConfigobj, c => c.boardNum == that.boardNum)
                    if (info) {
                        that.roomIds = info.roomIds || []
                        that.bedIds = info.bedIds || []
                    }
                } else {
                    that.roomIds = that.queryroomIds && that.queryroomIds.split(`,`) || []
                    that.bedIds = that.querybedIds && that.querybedIds.split(`,`) || []
                }
                resolve(config)
            })
        },
        handleResize(event, type) {
            event.stopPropagation()
            this.clientX = event.clientX
            this.clientY = event.clientY
            this.w = this.video.width
            this.h = this.video.height
            this.x = this.video.left
            this.y = this.video.top
            this.isCircleMove = true
            document.onmousemove = (ev) => {
                let _w = (this.clientX - ev.clientX) / this.scaleVal
                let _h = (this.clientY - ev.clientY) / this.scaleVal
                if (_w < 0 && Math.abs(_w) >= this.w) {
                    return false
                }
                if (_h < 0 && Math.abs(_h) >= this.h) {
                    return false
                }
                this.handleCircleMouseMove(ev, type)
            }
            document.onmouseup = () => {
                document.onmousemove = document.onmouseup = null
                this.isCircleMove = false
            }
        },
        handleCircleMouseMove(ev, type) {
            if (this.isCircleMove) {
                // 左
                if (type === `left`) {
                    this.video.width = this.w + (this.clientX - ev.clientX) / this.scaleVal
                    this.video.left = this.x + (ev.clientX - this.clientX) / this.scaleVal
                }
                // 右
                if (type === `right`) {
                    this.video.width = this.w + (ev.clientX - this.clientX) / this.scaleVal
                }
                // 上
                if (type === `top`) {
                    this.video.height = this.h + (this.clientY - ev.clientY) / this.scaleVal
                    this.video.top = this.y + (ev.clientY - this.clientY) / this.scaleVal
                }
                // 下
                if (type === `bottom`) {
                    this.video.height = this.h + (ev.clientY - this.clientY) / this.scaleVal
                }
                // 左上
                if (type === `leftTop`) {
                    this.video.width = this.w + (this.clientX - ev.clientX) / this.scaleVal
                    this.video.left = this.x + (ev.clientX - this.clientX) / this.scaleVal
                    this.video.height = this.h + (this.clientY - ev.clientY) / this.scaleVal
                    this.video.top = this.y + (ev.clientY - this.clientY) / this.scaleVal
                }
                // 左下
                if (type === `leftBottom`) {
                    this.video.width = this.w + (this.clientX - ev.clientX) / this.scaleVal
                    this.video.left = this.x + (ev.clientX - this.clientX) / this.scaleVal
                    this.video.height = this.h + (ev.clientY - this.clientY) / this.scaleVal
                }
                // 右上
                if (type === `rightTop`) {
                    this.video.width = this.w + (ev.clientX - this.clientX) / this.scaleVal
                    this.video.height = this.h + (this.clientY - ev.clientY) / this.scaleVal
                    this.video.top = this.y + (ev.clientY - this.clientY) / this.scaleVal
                }
                // 右下
                if (type === `rightBottom`) {
                    this.video.width = this.w + (ev.clientX - this.clientX) / this.scaleVal
                    this.video.height = this.h + (ev.clientY - this.clientY) / this.scaleVal
                }
            }
        },
        loadToken() {
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            return new Promise(resolve => {
                this.username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: this.username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    resolve(data)
                })
            })
        },
        loadConfigs() {
            return new Promise(resolve => {
                let that = this
                let req = this.myaxios.get(`/api/AcisSystem/BoardConfig/Get`)
                req.then(data => {
                    if (data) {
                        data = _.filter(data, d => {
                            return d.is_show && d.type == that.board_type
                        })
                        that.boardConfigs = _.cloneDeep(data)
                    }
                    console.log(`boardConfigs`, that.boardConfigs)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadTopList() {
            this.loadFamilyList(`top`).then(() => {
                this.setRowStyle(`top`)
            })
        },
        loadDownList() {
            this.loadFamilyList(`down`).then(() => {
                this.setRowStyle(`down`)
            })
        },
        init() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req1 = this.myaxios.get(`api/AcisSystem/SysUser/GetRegions?username=${this.username}`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    let owIds = data1.operating_wards.map(d => {
                        return `ow_${d.id}`
                    })
                    let rwIds = data1.recovery_wards.map(d => {
                        return `rw_${d.id}`
                    })

                    this.role_ids = owIds.concat(rwIds)
                    console.log(`用户手术区和复苏区权限Ids集合`, this.role_ids)
                    this.boardConfigPageInterval = _.filter(data, { key: `BoardConfigPageInterval` })[0] && _.filter(data, { key: `BoardConfigPageInterval` })[0].value
                    this.boardConfigAudio = _.filter(data, { key: `BoardConfigAudio` })[0] && _.filter(data, { key: `BoardConfigAudio` })[0].value
                    this.hosptialName = _.filter(data, { key: `HospitalName` })[0] && _.filter(data, { key: `HospitalName` })[0].value
                    this.boardLineHeight = _.filter(data, { key: `BoardLineHeight` })[0] && _.filter(data, { key: `BoardLineHeight` })[0].value
                    resolve(this.role_ids)
                })
            })
        },
        reseveMessage() {
            let that = this
            let wsImpl = window.WebSocket || window.MozWebSocket
            window.ws = new wsImpl(this.$root.BoardIP)
            var heartCheck = {
                timeout: 60000, // 60ms
                timeoutObj: null,
                reset: function() {
                    clearTimeout(this.timeoutObj)
                    this.start()
                },
                start: function() {
                    this.timeoutObj = setTimeout(function() {
                        ws.send(`HeartBeat`)
                    }, this.timeout)
                }
            }
            ws.onmessage = function(evt) {
                heartCheck.reset()
                if (evt.data != `HeartBeat`) {
                    console.log(`=====收到消息=====`, evt.data)
                    let data = JSON.parse(evt.data)
                    console.log(`=====序列化消息=====`, data)
                    if (data.type === `DP`) {
                        if ((that.roomIds && that.roomIds.length > 0) || (that.bedIds && that.bedIds.length > 0)) {
                            if (that.roomIds && that.roomIds.length > 0 && data.roomId && _.includes(that.roomIds, data.roomId)) {
                                that.noticeDatas.push(data)
                            }
                            if (that.bedIds && that.bedIds.length > 0 && data.bedId && _.includes(that.bedIds, data.bedId)) {
                                that.noticeDatas.push(data)
                            }
                        } else {
                            that.noticeDatas.push(data)
                        }
                        that.startToVoice()
                    }
                    if (that.active_ward.value !== data.receiver) {
                        return false
                    }
                }
            }
            ws.onopen = function() {
                heartCheck.start()
                console.log(`connection open,连接打开成功`)
            }
            ws.onclose = function(e) {
                console.log(`connection closed，连接关闭`)
                console.log(`websocket 断开：` + e.code + ` ` + e.reason + ` ` + e.wasClean)
                setTimeout(function() {
                    that.reseveMessage()
                }, 5000)
            }
        },
        loadConfig(config) {
            this.config = config
        },
        getBoardTime() {
            let that = this
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/Operation/BoardNotice/GetBoardTime`,
                        Object.assign(
                            {
                                headers: {
                                    Authorization: `bearer ${that.token}`
                                },
                                emulateJSON: true
                            }
                        )
                    )
                    .then(response => {
                        let nowtime = response && response.other && response.other.nowTime && this.$moment(response.other.nowTime).format(`YYYY年MM月DD日 HH:mm`)
                        this.$refs.board.nowtime = nowtime
                        console.log(`this.nowtime`, nowtime)
                    })
                    .catch(e => {
                        return reject(e)
                    })
            })
        },
        loadFamilyList(type) {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.roomIds || that.bedIds) {
                    axios
                        .post(
                            `/api/Operation/BoardNotice/GetCKFamilyNoticeList`,
                            { roomIds: that.roomIds, bedIds: that.bedIds },
                            Object.assign(
                                {
                                    headers: {
                                        Authorization: `bearer ${that.token}`
                                    },
                                    emulateJSON: true
                                }
                            )
                        )
                        .then(response => {
                            if (response.status === 200 && response.data) {
                                if (type === `top`) {
                                    that.items1 = response.data.ds
                                    that.$refs.board.pushRow1 = 0
                                } else if (type === `down`) {
                                    that.items2 = response.data.ds1
                                    that.$refs.board.pushRow2 = 0
                                } else {
                                    that.items1 = response.data.ds
                                    that.items2 = response.data.ds1
                                    that.$refs.board.pushRow1 = 0
                                    that.$refs.board.pushRow2 = 0
                                }
                                console.log(`response`, that.items1, that.items2)
                                resolve(response.data)
                            } else {
                                return reject(response.msg)
                            }
                        })
                        .catch(e => {
                            if (e && e.data && e.status == `600`) {
                                ElementUI.Message.error(e.data && e.data.detail)
                            } else if (e && e.data) {
                                ElementUI.Notification.error({
                                    title: `错误`,
                                    message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                                })
                            }
                            return reject(e)
                        })
                }
            })
        },
        setRowStyle(type) {
            let that = this
            if (that.boardConfigs.length == 0) return []
            let configInfo = []
            let list = []
            if (type == `top`) {
                configInfo = _.filter(that.boardConfigs, d => {
                    return d.is_split == 1
                })
                list = _.cloneDeep(that.items1 || [])
            } else {
                configInfo = _.filter(that.boardConfigs, d => {
                    return d.is_split == 2
                })
                list = _.cloneDeep(that.items2 || [])
            }
            let arr = []
            let items = []
            if (configInfo.length > 0) {
                if (list.length > 0) {
                    let titleObj = null
                    for (let obj of list) {
                        let r = ``
                        let t = ``
                        for (let c of configInfo) {
                            let info = `"${c.value}":{"label":"${obj[c.value] && obj[c.value].toString().replace(/"/g, `'`)}","span":${c.width},"display_order":"${c.display_order}","is_roll":${c.is_roll}}`
                            let title = `"${c.value}":{"label":"${c.name}","span":${c.width},"display_order":"0","display_back_color":"${c.display_back_color}","is_roll":false,"header_style":[${c.header_style}],"column_style":[${c.column_style}]}`
                            r = `${r + info},`
                            t = `${t + title},`
                        }
                        let rconfig = JSON.parse(`{${r.substring(0, r.length - 1)}}`)
                        titleObj = JSON.parse(`{${t.substring(0, t.length - 1)}}`)
                        // 如果配置的列中，没有手术状态列，加一个状态的隐藏列用于判断行背景色
                        let index = _.has(titleObj, `Enum_SurgeryStatus`)
                        if (!index) {
                            titleObj.Enum_SurgeryStatus = {
                                label: `手术状态枚举`,
                                span: 0,
                                display_order: `0`,
                                display_back_color: `#FF8C00`
                            }
                        }

                        let index1 = _.has(rconfig, `Enum_SurgeryStatus`)
                        if (!index1) {
                            rconfig.Enum_SurgeryStatus = {
                                label: `${obj[`Enum_SurgeryStatus`]}`,
                                span: 0,
                                display_order: `0`,
                                display_back_color: `#FF8C00`
                            }
                        }
                        if (that.BoardSurgerytypeColorObj != null) {
                            let index2 = _.has(rconfig, `SurgeryType`)
                            if (index2 && rconfig.SurgeryType.label != ``) {
                                rconfig.SurgeryType.color = that.BoardSurgerytypeColorObj[rconfig.SurgeryType.label]
                            }
                        }
                        arr.push(rconfig)
                    }
                    if (titleObj !== null) {
                        items.push(titleObj)
                    }
                } else {
                    let t2 = ``
                    for (let c2 of configInfo) {
                        // modify by xiaorui,加了display_back_color列，列头背景色就显示背景色，没有设置就显示行的背景色
                        let title2 = `"${c2.value}":{"label":"${c2.name}","span":${c2.width},"display_order":"0","display_back_color":"${c2.display_back_color}"}`
                        if (c2.header_style) {
                            title2 += `,"header_style":[${c2.header_style}]`
                        }
                        if (c2.column_style) {
                            title2 += `,"column_style":[${c2.column_style}]`
                        }
                        t2 = `${t2 + title2},`
                    }
                    let titleObj2 = JSON.parse(`{${t2.substring(0, t2.length - 1)}}`)
                    if (titleObj2 !== null) {
                        items.push(titleObj2)
                    }
                }
            }
            if (type == `top`) {
                that.topRows = items.concat(arr)
                console.log(`topRows`, that.topRows)
            } else {
                that.downRows = items.concat(arr)
                console.log(`downRows`, that.downRows)
            }
        },
        timer() {
            let that = this
            this.loadTime_timer = setInterval(() => {
                that.getBoardTime()
            }, 10000)
        },
        // 循环播放视频
        repeatPlayVideo() {
            let that = this
            this.$nextTick(function() {
                var index = 0
                var videoDom = document.getElementById(`video1`)
                if (videoDom && that.videoList.length > 0) {
                    console.log(`1 开始播放视频`, index, videoDom.ended)
                    videoDom.src = that.videoList[index].src
                    let playPromise = videoDom.play()
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            console.log(`播放失败`, e)
                            ElementUI.Message.error(`播放失败,请检查浏览器，设置>隐私设置和安全性>网站设置>声音:设置为允许/查看播放的视频文件是否存在`)
                        })
                    }
                    // 监控一个视频播放完成
                    videoDom.addEventListener(`ended`, function(event) {
                        console.log(`2 视频播放结束`, index, videoDom.ended)
                        index += 1
                        if (index == that.videoList.length) {
                            console.log(`4 全部视频播放完成,重新播放`, videoDom.ended)
                            index = 0
                            if (videoDom.ended) {
                                console.log(`5 重新加载后又一次开始播放视频`, index, videoDom.ended)
                                videoDom.src = that.videoList[index].src
                                videoDom.play()
                            }
                        } else {
                            if (videoDom.ended) {
                                console.log(`3 新一个视频开始播放`, index, videoDom.ended)
                                videoDom.src = that.videoList[index].src
                                videoDom.play()
                            }
                        }
                    })
                }
            })
        },
        // 暂停/重新播放
        pauseAndPlay() {
            let that = this
            this.$nextTick(function() {
                if (that.videoList && that.videoList.length > 0) {
                    var videoDom = document.getElementById(`video1`)
                    if (!that.isHide) {
                        videoDom.muted = true // 静音
                    } else {
                        videoDom.muted = false // 取消静音
                    }
                }
            })
        },
        startToVoice() {
            let r = this.noticeDatas[0]
            let recever = (r && r.receiver) || 0
            this.dic_operating_room = this.active_ward && this.active_ward.value
            let ids = _.filter(this.role_ids, d => {
                return d == recever
            })
            if (r && ids.length == 0) {
                console.log(`=====当前登录的用户没有播报对应手术区权限=======`)
            }
            if (this.noticeDatas.length != 0 && (r.receiver === this.dic_operating_room || ids.length != 0)) {
                console.log(`准备开始播报`)
                this.voiceBroadcast()
            } else {
                this.noticeDatas.shift()
            }
        },
        loadBoardVideoSetup() {
            // 1.根据客户端IP和屏幕类型，查询大屏视频设置
            // 2.此大屏做了视频播放设置
            let that = this
            return new Promise(resolve => {
                if (!this[`localip/ipAddress`]) return
                let req = this.myaxios.get(`/api/AcisSystem/BoardScreenConfig/GetByIP?screenType=${this.board_type}&boardIP=${this[`localip/ipAddress`]}`)
                req.then(data => {
                    let videoSetup = data
                    // 接口没查到大屏视频播放设置，不显示视频框
                    // 找到大屏视频播放设置
                    if (videoSetup) {
                        // 是否停放视频，enabled=false，不播放 隐藏
                        this.video.isHide = !videoSetup.enabled
                        if (videoSetup.enabled) {
                            // 屏幕开启了播放视频，一定显示视频吗，不一定,看是否设置了空闲时间段
                            // 设置了空闲时间段，
                            if (videoSetup.extra_option) {
                                let freeTimes = JSON.parse(videoSetup.extra_option)
                                let todayWeek = this.$moment().day().toString()
                                let tmpdate = this.$moment().format(`YYYY-MM-DD`)
                                let todayFreeTime = _.filter(freeTimes, c => {
                                    let startHHmm = this.$moment(c.startTime).format(`HH:mm`)
                                    let endHHmm = this.$moment(c.endTime).format(`HH:mm`)
                                    let start = that.$moment(tmpdate + ` ` + startHHmm)
                                    let end = that.$moment(tmpdate + ` ` + endHHmm)
                                    return _.includes(c.week, todayWeek) && start.diff(that.$moment(), `minutes`) <= 0 && end.diff(that.$moment(), `minutes`) >= 0
                                })

                                todayFreeTime = _.orderBy(todayFreeTime, `endTime`, `desc`)
                                if (todayFreeTime && todayFreeTime[0]) {
                                    this.video.isHide = !todayFreeTime[0].isshowvedio
                                    this.video.boardListHide = !todayFreeTime[0].isshowboard
                                }
                            }
                            if (!this.video.isHide) {
                                if (videoSetup.videoInfoList && videoSetup.videoInfoList.length == 0) {
                                    ElementUI.Message.warning(`没有要播放的视频文件`)
                                }
                                this.video.id = videoSetup.id
                                Object.assign(this.videoData, videoSetup)
                                // 没有设置top,left width时,视频默认屏幕一半
                                this.video.top = (!videoSetup.y_axis || videoSetup.y_axis == 0) ? this.messageTop : parseInt(videoSetup.y_axis)
                                this.video.left = (!videoSetup.x_axis || videoSetup.x_axis == 0) ? this.messageleft : parseInt(videoSetup.x_axis)
                                this.video.width = (!videoSetup.width || videoSetup.width == 0) ? this.messageWidth : parseInt(videoSetup.width)
                                this.video.height = (!videoSetup.height || videoSetup.height == 0) ? this.messageHeight : parseInt(videoSetup.height)
                                this.videoList = videoSetup.videoInfoList.map(d => {
                                    d.src = `${this.$root.BASE_URL}${d.file_address}`
                                    return d
                                })
                            }
                        }
                    }
                    resolve(data)
                })
            })
        },
        // 保存视图客户端移动设置
        savedragBoardSetup() {
            this.showBorder = false
            // 显示视频才保存
            if (!this.video.isHide) {
                let boardScreenSet = {
                    id: this.video.id,
                    width: parseInt(this.video.width),
                    height: parseInt(this.video.height),
                    y_axis: parseInt(this.video.top),
                    x_axis: parseInt(this.video.left),
                    board_ip: this.videoData.board_ip,
                    screen_type_enum: this.videoData.screen_type_enum,
                    extra_option: this.videoData.extra_option,
                    description: this.videoData.description,
                    enabled: this.videoData.enabled,
                    is_deleted: this.videoData.is_deleted,
                    creator: this.videoData.creator,
                    create_date: this.videoData.create_date,
                    modifier: this.videoData.modifier
                }
                let req = this.myaxios.put(`/api/AcisSystem/BoardScreenConfig/Put`, boardScreenSet)
                req.then(data => {
                    ElementUI.Message.warning(`调整视频播放位置成功`)
                }).catch(e => {
                    ElementUI.Message.error(`调整视频播放位置失败`)
                })
            }
        },
        voiceBroadcast() {
            let that = this
            let synth = window.speechSynthesis
            if (synth.speaking) {
                console.log(`上一条语音正在播放，请稍后`)
                return
            }

            that.message = that.noticeDatas[0].disaplayText.split(` `)
            let utterThis = new SpeechSynthesisUtterance(that.noticeDatas[0].readText)
            for (let i = 0; i < that.Voices.length; i++) {
                if (that.Voices[i].lang == `zh-CN`) {
                    utterThis.voice = that.Voices[i]
                    console.log(`匹配到中文语音包`)
                    break
                }
            }
            utterThis.pitch = 1
            utterThis.rate = 0.5
            utterThis.volume = 1
            utterThis.onerror = function(event) {
                console.log(`语音合成出错`, event)
            }
            let endIndex = 1
            utterThis.onend = function(event) {
                console.log(`要播${that.boardConfigAudio}次，现在播第${endIndex}次`, synth.speaking)
                if (endIndex == that.boardConfigAudio && !synth.speaking) {
                    that.noticeDatas.shift()
                    that.isHide = true
                    that.speaking = synth.speaking
                    console.log(`本条语音${that.boardConfigAudio}次全部播报完毕`)
                }
                endIndex += 1
            }
            that.speaking = true
            that.isHide = false
            for (let i = 0; i < this.boardConfigAudio; i++) {
                synth.speak(utterThis)
            }
        },
        getVoices() {
            let that = this
            let synth = window.speechSynthesis
            let id
            id = setInterval(() => {
                if (synth.getVoices().length !== 0) {
                    that.Voices = synth.getVoices()
                    console.log(`获取的语音包`, that.Voices)
                    clearInterval(id)
                }
            }, 100)
        }
    },
    destroyed() {
        clearInterval(this.loadTime_timer)
    },
    watch: {
        videoSource: function() {
            let that = this
            // 设置循环播放
            that.repeatPlayVideo()
        },
        isHide: function() {
            // 监控语音播报，当语音播报开始或者结束时触发视频播放暂停/重启
            let that = this
            that.pauseAndPlay()
        },
        speaking: function() {
            if (!this.speaking && this.noticeDatas.length > 0) {
                console.log(`下一条开始播报`)
                this.startToVoice()
            }
        }
    }
}
</script>

<style lang="less" scoped>
[v-cloak] {
    display: none !important;
}
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1f2d3d;
}
.message {
    position: fixed;
    top: 20%;
    left: 50%;
    width: 800px;
    min-height: 450px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    font-size: 64px;
}
.patient_name,
.note {
    height: 50%;
}
.active {
    display: none;
}
.bordercircle {
    height: 8px;
    width: 8px;
    border: 1px solid #2d60f6;
}
.video {
    position: fixed;
    color: #ffffff;
    z-index: 998;
    font-size: 64px;
    border: 1px solid #f1f3f4;
    .circle {
        position: absolute;
        border-radius: 50%;
        // height: 8px;
        // width: 8px;
        // border: 1px solid #2d60f6;
        background: #ffffff;
        &.circle-left {
            top: calc(50% - 10px);
            left: -11px;
        }
        &.circle-top {
            top: -11px;
            left: calc(50% - 10px);
        }
        &.circle-right {
            top: calc(50% - 10px);
            right: -11px;
        }
        &.circle-bottom {
            bottom: -11px;
            left: calc(50% - 10px);
        }
        &.ew-resize {
            cursor: ew-resize;
        }
        &.ns-resize {
            cursor: ns-resize;
        }
        &.nwse-resize {
            cursor: nwse-resize;
        }
        &.nesw-resize {
            cursor: nesw-resize;
        }
    }
}
.openVoice {
    position: fixed;
    z-index: 99;
    text-align: center;
    left: 50%;
    top: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 72px;
}
.display {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Board/UnloginObstetricsBoardFamily.vue